import { useEffect, useState } from 'react';
import { authImageUrl, fetchBlobUrl } from '../api';
import { bytes, Icon } from '../ui';

/** Фото оборудования: грузится с авторизацией, ссылки на файл нет. */
export function AuthImg({ path, alt = '', style }: { path: string; alt?: string; style?: Record<string, string | number> }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setUrl(null);
    authImageUrl(path)
      .then((u) => alive && setUrl(u))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [path]);
  return url ? <img src={url} alt={alt} style={style} /> : <span className="img-wait" aria-hidden="true" />;
}

/**
 * Видео оборудования: по нажатию загружается целиком в память (с ходом загрузки) и играет внутри приложения.
 * Ссылки на файл нет; при уходе со страницы память освобождается.
 */
export function AuthVideo({ path, size }: { path: string; size: number }) {
  const [state, setState] = useState<{ s: 'idle' } | { s: 'load'; share: number } | { s: 'ready'; url: string } | { s: 'error'; text: string }>({ s: 'idle' });
  useEffect(() => () => void (state.s === 'ready' && URL.revokeObjectURL(state.url)), [state]);

  async function load() {
    setState({ s: 'load', share: 0 });
    try {
      const url = await fetchBlobUrl(path, (share) => setState({ s: 'load', share }));
      setState({ s: 'ready', url });
    } catch (e) {
      setState({ s: 'error', text: e instanceof Error ? e.message : 'Видео не загрузилось' });
    }
  }

  if (state.s === 'ready') return <video src={state.url} controls playsInline autoPlay />;
  return (
    <button type="button" className="video-wait" onClick={() => state.s !== 'load' && void load()}>
      {state.s === 'load' ? (
        <span className="stack" style={{ gap: 8, width: '70%' }}>
          <span className="small">Загружаю видео… {Math.round(state.share * 100)}%</span>
          <span className="progress">
            <i style={{ width: `${Math.round(state.share * 100)}%` }} />
          </span>
        </span>
      ) : (
        <span className="stack" style={{ gap: 6, alignItems: 'center' }}>
          <span className="video-play">
            <Icon name="play" size={26} />
          </span>
          <span className="small">{state.s === 'error' ? `${state.text} — нажмите, чтобы повторить` : `Смотреть · ${bytes(size)}`}</span>
        </span>
      )}
    </button>
  );
}
